<nb-card>
  <form [formGroup]="forgotForm" novalidate (ngSubmit)="onSubmit()">
      <div class="form-control-group">
        <label i18n="@@ForgotPasswordSmsHint">Укажите ваш номер телефона</label>
        <input phoneMask maxlength="18" formControlName="phone" nbInput id="resetInputEmail1" type="tel"
               fullWidth i18n-placeholder="@@PhoneNumber" placeholder="Только цифры" autocomplete="off">
      </div>
      @if (attemptError) {
        <div class="invalid-feedback" i18n="@@WaitFor">подождите {{ timeLeft | formatTime }} мин.</div>
      }
      @if (verifyError) {
        <div class="invalid-feedback" i18n="@@WaitFor">{{ verifyErrorData }}</div>
      }
      @if (counterStarted) {
        <div class="invalid-feedback" i18n="@@NextVerificationUntil">
          вам отправлен sms с кодом. повторная проверка возможна через
          <span class="badge text-bg-primary">{{ counter | formatTime }}</span>
        </div>
      }
      @if (forgotForm.controls.phone.errors?.required && forgotForm.controls.phone.touched) {
        <div class="invalid-feedback" i18n>укажите номер телефона</div>
      }

      @let codeValid = codeValidated | async;
      @let passFieldsValid = isValidPassFields | async;
      @let isValid = isValidForm | async;

      @if (smsCodeFieldOpened) {
        <div class="form-control-group">
          <div class="form-control-group">
            <input nbInput id="signupInputCode" formControlName="smsCode" i18n-placeholder="@@SmsCode"
                   placeholder="Код из смс *" required>
            &nbsp;<button [disabled]="!forgotForm.controls.smsCode.valid" (click)="checkSmsCode()" type="button"
                          nbButton size="tiny" status="warning">
              подтвердить код
              @if (codeValid === true) {
                <tui-icon icon="circle-check" status="success" />
              }
              @if (codeValid === false) {
                <tui-icon icon="circle-alert" status="danger" />
              }
            </button>
          </div>
          @if (codeValid === false) {
            <div class="invalid-feedback" i18n="@@CodeInvalid">не верный код</div>
          }
          @if (codeValid === true) {
            <div class="valid-feedback" i18n="@@CodeVerified">код проверен</div>
          }
          @if (forgotForm.controls.smsCode.invalid && forgotForm.controls.smsCode.touched) {
            <div class="invalid-feedback" i18n="@@SmsCodeNotValid">код не верен</div>
          }
        </div>
      }

      @if (codeValid) {
        <div class="form-control-group">
          <div class="form-control-group">
            <input nbInput type="password" formControlName="password" i18n-placeholder="@@Password"
                   placeholder="Введите пароль *" required>
          </div>
          @if (forgotForm.controls.password.errors?.minlength && forgotForm.controls.password.touched) {
            <div class="invalid-feedback" i18n="@@PasswordTooShort">пароль слишком короткий</div>
          }
          @if (forgotForm.controls.password.errors?.required && forgotForm.controls.password.touched) {
            <div class="invalid-feedback" i18n="@@PasswordIsEmpty">укажите пароль</div>
          }

          <div class="form-control-group" style="margin-top: 18px">
            <input nbInput type="password" formControlName="repeatPassword" i18n-placeholder="@@PasswordRepeat"
                   placeholder="Повторите пароль *" required>
          </div>
          @if (forgotForm.controls.repeatPassword.errors?.minlength && forgotForm.controls.repeatPassword.touched) {
            <div class="invalid-feedback" i18n="@@PasswordTooShort">пароль слишком короткий</div>
          }
          @if (forgotForm.controls.repeatPassword.errors?.required && forgotForm.controls.repeatPassword.touched) {
            <div class="invalid-feedback" i18n="@@RepeatPasswordIsEmpty">подтвердите пароль</div>
          }
          @if (!passFieldsValid && forgotForm.touched) {
            <div class="invalid-feedback" style="margin-left: 40%" i18n="@@PasswordsAreNotIdentical">
              пароли не совпадают
            </div>
          }
        </div>
      }
      <nb-card-footer>
        <button [hidden]="!isValid || !codeValid" nbButton type="submit"
                i18n="@@ChangePassword" status="primary" size="large">Изменить пароль</button>
        <button (click)="checkNumber()"
                [disabled]="!forgotForm.controls.phone.valid || forgotForm.controls.phone.disabled"
                nbButton size="large" type="button" status="primary" i18n="@@SendCode">Выслать код</button>
      </nb-card-footer>
    </form>
</nb-card>
